/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import styled from "styled-components";

/**
 * Styles for img element
 */
export const StatusImg = styled.img`
  vertical-align: middle;
`;

/**
 * Styles for span elements
 */
export const StatusSpan = styled.span`
  margin-left: 5px;
  padding: 2px;
  position: absolute;
`;
